import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Asterisk: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M12 6v12' }],
    ['path', { d: 'M17.196 9 6.804 15' }],
    ['path', { d: 'm6.804 9 10.392 6' }],
  ],
];

export default Asterisk;
